import { render, staticRenderFns } from "./MerchantCompanyComponent.vue?vue&type=template&id=1dfa3dbc&"
import script from "./MerchantCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./MerchantCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports